export const I18nPrefix = 'strava.accounts.summary.subscriber';

export default { I18nPrefix };
